import { render, staticRenderFns } from "./ScannerPackagesForDriverAssignmentView.vue?vue&type=template&id=d2df60f0&scoped=true&lang=pug"
import script from "./ScannerPackagesForDriverAssignmentView.vue?vue&type=script&lang=js"
export * from "./ScannerPackagesForDriverAssignmentView.vue?vue&type=script&lang=js"
import style0 from "./ScannerPackagesForDriverAssignmentView.vue?vue&type=style&index=0&id=d2df60f0&prod&lang=scss&scoped=true"
import style1 from "./ScannerPackagesForDriverAssignmentView.vue?vue&type=style&index=1&id=d2df60f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2df60f0",
  null
  
)

export default component.exports